import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

/*
  - layout
*/
import Header from './layout/Header';
import Loading from './layout/Loading';

/*
  - page
*/
import Dashboard from './pages/Dashboard';
import Favorite from './pages/Favorite';
import Finance from './pages/Finance';
import Passenger from './pages/Passenger';
import Profile from './pages/Profile';
import Request from './pages/Request';
import Reserve from './pages/Reserve';
import User from './pages/User';
import { useCookies } from 'react-cookie'
import { FinanceProvider } from './context/FinanceContext';

/*
    - api
*/
import getAPI from './api/get';
import NotFound from './components/NotFound';
import LangLayout from './layout/LangLayout';

const App = () => {
  let AccessToken = localStorage.getItem('AccessToken');
  // debugger
  if (!AccessToken){
     window.location.href = 'https://iranhotelonline.com';
  }

  /*
    - defaultData
  */
  const [type, setType] = React.useState('');
  const [statusUser, setStatusUser] = React.useState('');
  const [UserData, setUserData] = React.useState('');
  React.useEffect(() => {
    const fetchData = async () => {
      let userRegisterType = '';
      let userRegisterProfile = '';
      let userRegisterTypeParameters = {
        ctrl: 'UserProfile',
        method: 'GetUserRegisterTypes',
        query: ''
      }
      let userProfileParameters = {
        ctrl: 'UserProfile',
        method: 'GetUserProfile',
        query: ''
      }
      userRegisterProfile = await getAPI(userProfileParameters);
      userRegisterType = await getAPI(userRegisterTypeParameters);
      setStatusUser(userRegisterProfile.data?.loginAsUser ? userRegisterProfile.data?.loginAsUser : false);
      setUserData(userRegisterProfile);
      if (userRegisterType.status === 200) {
        if (userRegisterType.data.some((obj) => (obj.registerType === 3))) {
          localStorage.setItem('type', 'B2B');
          document.title = 'B2B Dashbaord';
          setType('B2B');
        } else {
          localStorage.setItem('type', 'B2C');
          document.title = 'B2C Dashboard';
          setType('B2C');
        }
      }
    }
    fetchData();
  }, []);

  /*
    - reloadLayout
  */
  const [reloadHeader, setReloadHeader] = React.useState('');
  const reloadHeaderProps = (reloadHeaderProps) => {
    setReloadHeader(reloadHeaderProps);
  }
  return (
    
    <React.Fragment>
      <Router>
        {type === '' &&
          <Loading />
        }
        <Header props={reloadHeader} userData={UserData} userStatus={statusUser} />
        <Routes>
          <Route path='/dashboard/:paymentStatus' element={<Dashboard reloadHeaderProps={reloadHeaderProps} />} />
          {!statusUser  ?
          <>
              <Route path='/dashboard/' element={<Dashboard reloadHeaderProps={reloadHeaderProps} />} />
              <Route path='/passenger' element={<Passenger />} />
              <Route path='/reserve' element={<Reserve />} />
              <Route path='/favorite' element={<Favorite />} />
              <Route path='/request' element={<Request />} />
              <Route path='/request/:history' element={<Request />} />
          </>
          
            : ''}
          <Route path='/finance/report' element={
            <FinanceProvider>
              <Finance />
            </FinanceProvider>
          } />
          <Route path='/finance/settlement' element={
            <FinanceProvider>
              <Finance />
            </FinanceProvider>
          } />
          <Route path='/finance/bank' element={
            <FinanceProvider>
              <Finance />
            </FinanceProvider>
          } />
          <Route path='/user/sub-organization' element={<User />} />
          <Route path='/user/member' element={<User />} />
          <Route path='/profile/base-info' element={<Profile />} />
          <Route path='/profile/boss-info' element={<Profile />} />
          <Route path='/profile/officer-info' element={<Profile />} />
          <Route path='/profile/upload-license' element={<Profile />} />
          <Route path='/profile/change-pass' element={<Profile />} />
          <Route path='/user/passenger' element={<User />} />
          <Route path='/user/agent' element={<User />} />
        </Routes>
      </Router>
    </React.Fragment>
  );

}

export default App;
